import React from "react";

const Bash_Get_Started = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Get Started</h2>
      <p>Open a terminal (Ctrl+Alt+T on many distros) and try basic navigation commands. Create files with <code>touch</code>, edit with <code>nano</code> or <code>vim</code>.</p><h4 className="font-medium mt-4">First steps</h4><pre><code>pwd
ls -la
cd ~
mkdir project
cd project
touch hello.sh</code></pre>
    </div>
  );
};

export default Bash_Get_Started;
